/**
 * Test IDs for PlayArea component elements
 * This library provides a centralized way to generate test IDs for room view elements
 * to ensure consistency between the component and tests.
 */
export const playAreaTestIds = {
  /**
   * Generate test ID for a "Start Game" button based on game ID
   * @param gameId - The game ID (e.g., 'tictactoe', 'battleship')
   * @returns Test ID string (e.g., 'room-start-tictactoe-button')
   */
  getStartGameButtonTestId: (gameId: string): string => {
    return `room-start-${gameId}-button`;
  },

  /**
   * Test ID for the "Add AI Player" button
   */
  addAIPlayerButton: 'room-add-ai-player-button',

  /**
   * Test ID for the "End Game" button
   */
  endGameButton: 'room-end-game-button',

  /**
   * Test ID for the note shown to non-hosts in a managed room with no game
   */
  waitingForHost: 'room-waiting-for-host',

  /**
   * Test ID for the owner's Show all games toggle in a curated room
   */
  showAllGamesToggle: 'room-show-all-games-toggle',

  /**
   * Test ID for a curation action on a game tile (add, remove)
   */
  getCurationActionTestId: (action: 'add' | 'remove', gameId: string): string => {
    return `room-curation-${action}-${gameId}`;
  },
} as const

